import { Box, Flex, RadioProps, useRadio } from '@chakra-ui/react';

type Props = RadioProps;

export function RadioButton({ ...props }: Props): JSX.Element {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label" boxSize="full">
      <input {...input} />
      <Flex
        {...checkbox}
        alignItems="center"
        borderColor="gray.300"
        borderWidth="3px"
        cursor="pointer"
        fontWeight="500"
        h="full"
        lineHeight="1.4"
        p="4"
        rounded="md"
        textColor="gray.900"
        _checked={{
          borderColor: 'secondary',
          textColor: 'gray.800',
        }}
      >
        {props.children}
      </Flex>
    </Box>
  );
}

export type RadioButtonProps = Props;
